import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  pillDirection: {
    default: 'row',
    editor: 'dropdown',
    editorOptions: ['row', 'column'],
  },
  pillAlign: {
    default: 'left',
    editor: 'dropdown',
    editorOptions: ['left', 'right', 'center'],
  },
  pillSize: {
    default: 'medium',
    editor: 'dropdown',
    editorOptions: ['small', 'medium', 'large'],
  },
  type: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['light', 'dark'],
  },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
};

const PlaygroundKnobsv3: Knobs = {
  pillSize: {
    default: 'medium',
    editor: 'dropdown',
    editorOptions: ['', 'small', 'medium', 'large'],
    delimiter: '\n  ',
  },
  type: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'light', 'dark'],
    delimiter: '\n  ',
  },
  pillAlign: {
    default: 'left',
    editor: 'dropdown',
    editorOptions: ['left', 'right', 'center'],
    delimiter: '\n  ',
  },
  pillStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n  ',
  },
  textStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n  ',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['', 'desktop', 'mobile'],
    default: '',
  },
};

const PlaygroundKnobsv3React: Knobs = {
  ...PlaygroundKnobsv3,
  pillStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n  ',
    qualifierStart: '{',
    qualifierEnd: '}',
  },
  textStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n  ',
    qualifierStart: '{',
    qualifierEnd: '}',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-pills where you can change all the attributes',
  coreComponent: {
    html: `<tag-pills {{...knobs}} >
  <tag-pill text='APPLE'></tag-pill>
  <tag-pill text='ORANGE'></tag-pill>
  <tag-pill text='PEAR'></tag-pill>
  <tag-pill text='BANANNA'></tag-pill>
  <tag-pill text='KIWI'></tag-pill>
</tag-pills>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: {
    jsx: `<TagPills{{...knobs}}
  pills={[
    {
      action: true,
      text: 'APPLE',
    },
    {
      action: true,
      text: 'ORANGE',
    },
    {
      action: true,
      text: 'PEAR',
    },
    {
      action: true,
      text: 'BANANNA',
    },
    {
      action: true,
      text: 'KIWI',
    },
  ]}
/>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `
<tag3-pills {{...knobs}}
>
  <tag3-pill name="APPLE">APPLE</tag3-pill>
  <tag3-pill>ORANGE</tag3-pill>
  <tag3-pill>PEAR</tag3-pill>
  <tag3-pill>BANANNA</tag3-pill>
  <tag3-pill>KIWI</tag3-pill>
</tag3-pills>
`,
    knobs: PlaygroundKnobsv3,
  },
  reactWrapper_v3: {
    jsx: `
<Tag3Pills {{...knobs}}
  pills={[
    {
      name: 'apple',
      text: 'APPLE',
    },
    {
      name: 'orange',
      text: 'ORANGE',
    },
    {
      name: 'pear',
      text: 'PEAR',
    },
    {
      name: 'banana',
      text: 'BANANNA',
    },
    {
      name: 'kiwi',
      text: 'KIWI',
    },
  ]}
/>
    `,
    knobs: PlaygroundKnobsv3React,
  },
};

const ChildrenStory: Story = {
  title: "Child Tag-Pill's",
  description: 'A tag-pills where you can change all the attributes',
  reactWrapper_v3: {
    jsx: `
<Tag3Pills {{...knobs}}
>
  <Tag3Pill name="apple">
    APPLE
  </Tag3Pill>
  <Tag3Pill name="orange">
    ORANGE
  </Tag3Pill>
  <Tag3Pill name="pear">
    PEAR
  </Tag3Pill>
  <Tag3Pill name="banana">
    BANANA
  </Tag3Pill>
  <Tag3Pill name="kiwi">
    KIWI
  </Tag3Pill>
</Tag3Pills>
    `,
    knobs: PlaygroundKnobsv3React,
  },
};

const UpdateStory: Story = {
  title: 'Update pills',
  description: 'A tag-pills where you can change all the attributes',
  coreComponent_v3: {
    html: `
  <tag3-pills pill-align="left" pill-size="medium" type="light"></tag3-pills>
  <div class="btns">
    <tag3-button>Add Pill</tag3-button>
    <tag3-button>Remove Pill</tag3-button>
  </div>
`,
    js: `
var pills = document.querySelector('tag3-pills');

pills.pills = [
  {
    name: 'pill1',
    text: 'PILL 1',
  },
  {
    name: 'pill2',
    text: 'PILL 2',
  },
]

document.querySelector('.btns').addEventListener('buttonClick',buttonClick);

function buttonClick(e) {

  var newPillNumber = pills.pills.length +1;

  //.trim() to address IE issue
  switch(e.target.innerText.trim()) {
    case "Add Pill":
      pills.pills = pills.pills.concat({name: 'pill' + newPillNumber, text: 'PILL ' + newPillNumber});
      break;
    case "Remove Pill":
      var newPills = pills.pills;
      if (newPills.length > 1) {
        pills.pills = newPills.slice(0, -1);
      }
      break;

  }
}
    `,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
      const [pills, setPills] = React.useState([
        {
          name: 'pill1',
          text: 'PILL 1',
        },
        {
          name: 'pill2',
          text: 'PILL 2',
        },
      ]);

      const handleAddButtonClick = () => {
        setPills([...pills, {text: 'PILL ' + (pills.length + 1), name: 'pills' + (pills.length + 1)}]);
      }

      const handleRemoveButtonClick= () => {
        const newPills = [...pills];
        if (newPills.length > 1) {
          newPills.pop();
          setPills(newPills)
        }
      }

      return (
        <div>
          <Tag3Pills
            pillAlign="left"
            pillSize="medium"
            type="light"
            pills={[...pills]}
            ></Tag3Pills>
          <Tag3Button onButtonClick={handleAddButtonClick} text="Add pill"/>
          <Tag3Button onButtonClick={handleRemoveButtonClick} text="Remove pill" disabled={pills.length === 1}/>
        </div>
      )
    };
    `,
  },
};

const WrapStory: Story = {
  title: 'Wrap',
  description: 'A tag-pills where the pills wrap to multiple rows',
  coreComponent: {
    html: `<div style="width:150px;">
  <tag-pills>
    <tag-pill text='Apple'></tag-pill>
    <tag-pill text='Orange'></tag-pill>
    <tag-pill text='Pear'></tag-pill>
    <tag-pill text='Banana'></tag-pill>
    <tag-pill text='Kiwi'></tag-pill>
  </tag-pills>
</div>`,
  },
  reactWrapper: {
    jsx: `<div style={{width:"150px"}}>
  <TagPills
    pills={[
      {
        text: 'Apple',
      },
      {
        text: 'Orange',
      },
      {
        text: 'Pear',
      },
      {
        text: 'Banana',
      },
      {
        text: 'Kiwi',
      },
    ]}
  />
</div>`,
  },
  coreComponent_v3: {
    html: `<div style="width:150px;">
  <tag3-pills>
    <tag3-pill>Apple</tag3-pill>
    <tag3-pill>Orange</tag3-pill>
    <tag3-pill>Pear</tag3-pill>
    <tag3-pill>Banana</tag3-pill>
    <tag3-pill>Kiwi</tag3-pill>
  </tag3-pills>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<div style={{width:"150px"}}>
  <Tag3Pills>
    <Tag3Pill>Apple</Tag3Pill>
    <Tag3Pill>Orange</Tag3Pill>
    <Tag3Pill>Pear</Tag3Pill>
    <Tag3Pill>Banana</Tag3Pill>
    <Tag3Pill>Kiwi</Tag3Pill>
  </Tag3Pills>
</div>`,
  },
};

export const TagPillsDocs: Component = {
  type: 'component',
  name: 'pills',
  description: 'Renders a set of pills',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'pillAlign',
      description: 'The alignment for the pills (left | right)',
      type: 'left | right | center',
      default: 'left',
    },
    {
      name: 'pillDirection',
      description: 'DEPRECATED in v3. Whether to display columns by row or column (row | column)',
      type: 'string',
      default: 'row',
    },
    {
      name: 'pillSize',
      description: 'The default sizing of the pills (small | medium | large)',
      type: 'string',
      default: 'medium',
    },
    {
      name: 'pillStyle',
      description: 'JSX style object in JSON to apply to the pill container',
      type: 'string',
    },
    {
      name: 'textStyle',
      description: 'JSX style object in JSON to apply to the pill text',
      type: 'string',
    },
    {
      name: 'containerStyle',
      description: 'JSX style object in JSON to apply to the container',
      type: 'string',
    },
    {
      name: 'pillCloseIcon',
      description: 'DEPRECATED in v3. Icon to use for the pill close button',
      type: 'Icon',
      default: 'CircleCross',
    },
    {
      name: 'type',
      description:
        'Pill display style (light | dark). V3: Defaults to "dark" for color-scheme="dark"',
      type: 'string',
      default: 'light',
    },
    {
      name: 'pills',
      description: 'An array of ITagPill items',
      type: 'ITagPill[]',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [
    {
      name: 'pills',
      description: 'An array of ITagPill items',
      type: 'ITagPill[]',
    },
  ],
  events: [
    {
      name: 'pillClick',
      description: 'Event raised when a pill is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the pill',
          type: 'string',
        },
      ],
    },
    {
      name: 'pillCloseClick',
      description: 'DEPRECATED in v3. Event raised when a pill close button is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the pill',
          type: 'string,',
        },
        {
          name: 'pills',
          description: 'A collection of pills with the clicked item removed',
          type: 'ITagPill[]',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'setPills',
      description: 'DEPRECATED in v3. Method to set the pills',
      parameters: [
        {
          name: 'pills',
          description: 'A collection of pills',
          type: 'ITagPill[]',
        },
      ],
      returnType: 'void',
    },
  ],
  stories: [PlaygroundStory, ChildrenStory, UpdateStory, WrapStory],
};
